<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Telefon komórkowy'"
      [data]="beneficiary().telefon1"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Adres e-mail'"
      [data]="beneficiary().email"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
</div>
